import { render, staticRenderFns } from "./personalSet.vue?vue&type=template&id=0f12ede8&scoped=true"
import script from "./personalSet.vue?vue&type=script&lang=js"
export * from "./personalSet.vue?vue&type=script&lang=js"
import style0 from "./personalSet.vue?vue&type=style&index=0&id=0f12ede8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f12ede8",
  null
  
)

export default component.exports